// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splitPane_HDPGa {
  --thickness: 1px;
}
.splitPane_HDPGa .Pane + .Resizer {
  opacity: 1;
  --offset1: 0px;
  --offset2: 1px;
  --bordertop: 5px;
  --borderleft: 5px;
  --borderright: 5px;
  --borderbottom: 5px;
  background-clip: padding-box;
  --bordertopcolor: rgba(255, 255, 255, 0);
  --bordertopstyle: solid;
  background-color: transparent;
  --borderleftcolor: rgba(255, 255, 255, 0);
  --borderleftstyle: solid;
  --borderrightcolor: rgba(255, 255, 255, 0);
  --borderrightstyle: solid;
  --borderbottomcolor: rgba(255, 255, 255, 0);
  --borderbottomstyle: solid;
}
.splitPane_HDPGa .Pane + .Resizer.vertical {
  width: calc( var(--thickness) + var(--borderleft) + var(--borderright) );
  --offset1: 1px;
  --offset2: 0px;
  min-width: calc( var(--thickness) + var(--borderleft) + var(--borderright) );
  --thickness: 1px;
  margin-left: calc( 0px - var(--borderleft) - var(--offset1) );
  margin-right: calc( 0px - var(--borderright) - var(--offset2) );
  border-left-color: var(--borderleftcolor);
  border-left-width: var(--borderleft);
  border-left-style: var(--borderleftstyle);
  border-right-color: var(--borderrightcolor);
  border-right-width: var(--borderright);
  border-right-style: var(--borderrightstyle);
}
.splitPane_HDPGa .Pane + .Resizer.horizontal {
  height: calc( var(--thickness) + var(--bordertop) + var(--borderbottom) );
  --offset1: 1px;
  --offset2: 0px;
  min-height: calc( var(--thickness) + var(--bordertop) + var(--borderbottom) );
  margin-top: calc( 0px - var(--bordertop) - var(--offset1) );
  --thickness: 1px;
  margin-bottom: calc( 0px - var(--borderbottom) - var(--offset2) );
  border-top-color: var(--bordertopcolor);
  border-top-width: var(--bordertop);
  border-top-style: var(--bordertopstyle);
  border-bottom-color: var(--borderbottomcolor);
  border-bottom-width: var(--borderbottom);
  border-bottom-style: var(--borderbottomstyle);
}
.splitPane_HDPGa .Pane + .Resizer:hover {
  --bordertopcolor: rgba(0, 0, 0, 0.5);
  --borderleftcolor: rgba(0, 0, 0, 0.5);
  --borderrightcolor: rgba(0, 0, 0, 0.5);
  --borderbottomcolor: rgba(0, 0, 0, 0.5);
}
.splitPane_HDPGa .Pane + .Resizer.horizontal:hover {
  --bordertopcolor: var( --color-brand200 );
  --borderbottomcolor: var( --color-brand200 );
}
.splitPane_HDPGa .Pane + .Resizer.vertical:hover {
  --borderleftcolor: var( --color-brand200 );
  --borderrightcolor: var( --color-brand200 );
}
.splitPane_HDPGa .Pane1 {
  z-index: 1;
  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );
  background-color: var( --color-white );
}
.splitPane_HDPGa .Pane2 {
  background-color: var( --color-white );
}`, "",{"version":3,"sources":["webpack://./src/theme/SplitPane.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,wCAAwC;EACxC,uBAAuB;EACvB,6BAA6B;EAC7B,yCAAyC;EACzC,wBAAwB;EACxB,0CAA0C;EAC1C,yBAAyB;EACzB,2CAA2C;EAC3C,0BAA0B;AAC5B;AACA;EACE,wEAAwE;EACxE,cAAc;EACd,cAAc;EACd,4EAA4E;EAC5E,gBAAgB;EAChB,6DAA6D;EAC7D,+DAA+D;EAC/D,yCAAyC;EACzC,oCAAoC;EACpC,yCAAyC;EACzC,2CAA2C;EAC3C,sCAAsC;EACtC,2CAA2C;AAC7C;AACA;EACE,yEAAyE;EACzE,cAAc;EACd,cAAc;EACd,6EAA6E;EAC7E,2DAA2D;EAC3D,gBAAgB;EAChB,iEAAiE;EACjE,uCAAuC;EACvC,kCAAkC;EAClC,uCAAuC;EACvC,6CAA6C;EAC7C,wCAAwC;EACxC,6CAA6C;AAC/C;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,sCAAsC;EACtC,uCAAuC;AACzC;AACA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;AACA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,oFAAoF;EACpF,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC","sourcesContent":[".splitPane {\n  --thickness: 1px;\n}\n.splitPane :global( .Pane + .Resizer ) {\n  opacity: 1;\n  --offset1: 0px;\n  --offset2: 1px;\n  --bordertop: 5px;\n  --borderleft: 5px;\n  --borderright: 5px;\n  --borderbottom: 5px;\n  background-clip: padding-box;\n  --bordertopcolor: rgba(255, 255, 255, 0);\n  --bordertopstyle: solid;\n  background-color: transparent;\n  --borderleftcolor: rgba(255, 255, 255, 0);\n  --borderleftstyle: solid;\n  --borderrightcolor: rgba(255, 255, 255, 0);\n  --borderrightstyle: solid;\n  --borderbottomcolor: rgba(255, 255, 255, 0);\n  --borderbottomstyle: solid;\n}\n.splitPane :global( .Pane + .Resizer.vertical ) {\n  width: calc( var(--thickness) + var(--borderleft) + var(--borderright) );\n  --offset1: 1px;\n  --offset2: 0px;\n  min-width: calc( var(--thickness) + var(--borderleft) + var(--borderright) );\n  --thickness: 1px;\n  margin-left: calc( 0px - var(--borderleft) - var(--offset1) );\n  margin-right: calc( 0px - var(--borderright) - var(--offset2) );\n  border-left-color: var(--borderleftcolor);\n  border-left-width: var(--borderleft);\n  border-left-style: var(--borderleftstyle);\n  border-right-color: var(--borderrightcolor);\n  border-right-width: var(--borderright);\n  border-right-style: var(--borderrightstyle);\n}\n.splitPane :global( .Pane + .Resizer.horizontal ) {\n  height: calc( var(--thickness) + var(--bordertop) + var(--borderbottom) );\n  --offset1: 1px;\n  --offset2: 0px;\n  min-height: calc( var(--thickness) + var(--bordertop) + var(--borderbottom) );\n  margin-top: calc( 0px - var(--bordertop) - var(--offset1) );\n  --thickness: 1px;\n  margin-bottom: calc( 0px - var(--borderbottom) - var(--offset2) );\n  border-top-color: var(--bordertopcolor);\n  border-top-width: var(--bordertop);\n  border-top-style: var(--bordertopstyle);\n  border-bottom-color: var(--borderbottomcolor);\n  border-bottom-width: var(--borderbottom);\n  border-bottom-style: var(--borderbottomstyle);\n}\n.splitPane :global( .Pane + .Resizer:hover ) {\n  --bordertopcolor: rgba(0, 0, 0, 0.5);\n  --borderleftcolor: rgba(0, 0, 0, 0.5);\n  --borderrightcolor: rgba(0, 0, 0, 0.5);\n  --borderbottomcolor: rgba(0, 0, 0, 0.5);\n}\n.splitPane :global( .Pane + .Resizer.horizontal:hover ) {\n  --bordertopcolor: var( --color-brand200 );\n  --borderbottomcolor: var( --color-brand200 );\n}\n.splitPane :global( .Pane + .Resizer.vertical:hover ) {\n  --borderleftcolor: var( --color-brand200 );\n  --borderrightcolor: var( --color-brand200 );\n}\n.splitPane :global( .Pane1 ) {\n  z-index: 1;\n  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );\n  background-color: var( --color-white );\n}\n.splitPane :global( .Pane2 ) {\n  background-color: var( --color-white );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"splitPane": `splitPane_HDPGa`
};
export default ___CSS_LOADER_EXPORT___;
